<template>
    <div>
        <vk-tabs-vertical v-if="veiculo && ! isMobile()">
            <vk-tabs-item title="OBS" style="height: 280px">
                <label for="hora_inicial_noturno" class="col-sm-6 control-label">OBS DO VEÍCULO:</label>
                <textarea v-model="veiculo.obs" style="height: 200px !important;" class="form-control"></textarea>
            </vk-tabs-item>

            <vk-tabs-item title="DIREÇÃO NOTURNA"  style="height: 280px">
                <form-direcao-noturna :veiculo="veiculo"></form-direcao-noturna>
            </vk-tabs-item>
        </vk-tabs-vertical>
        <vk-tabs v-else-if="veiculo" >
            <vk-tabs-item title="OBS" style="height: 280px">
                <label for="hora_inicial_noturno" class="col-sm-6 control-label">OBS DO VEÍCULO:</label>
                <textarea v-model="veiculo.obs" style="height: 200px !important;" class="form-control"></textarea>
            </vk-tabs-item>

            <vk-tabs-item title="DIREÇÃO NOTURNA"  style="height: 280px">
                <form-direcao-noturna :veiculo="veiculo"></form-direcao-noturna>
            </vk-tabs-item>
        </vk-tabs>
    </div>

</template>

<script>
import FormDirecaoNoturna from '../../forms/FormDirecaoNoturna.vue';
import {isMobile} from '../../../utils/is-celular';

export default {
    name: 'DadosDoVeiculoAdmin',
    methods: {
        isMobile() {
            return isMobile()
        }
    },
    components: {FormDirecaoNoturna},
    props: {
        veiculo: {
            defaultValue: null
        }
    }
};
</script>

<style scoped>

</style>
